export enum MetricCatalogView {
    LIST = 'list',
    CANVAS = 'canvas',
}
